import { mergeStyleSets } from "@fluentui/react";

export const useStyles = () => {
	return mergeStyleSets({
		root: {
			margin: "0px 30px 30px 30px",
		},
	});
};
